import { Role } from '@/types';
export const generalGetters = {
    selectedWorkspace: state => state.selectedWorkspace,
    statusLoginSpinner: state => state.statusLoginSpinner,
    isVaultAdmin: state => { var _a; return ((_a = state.selectedWorkspace) === null || _a === void 0 ? void 0 : _a.role) === Role.VAULT_ADMIN; },
    isVaultUser: state => { var _a, _b; return ((_a = state.selectedWorkspace) === null || _a === void 0 ? void 0 : _a.role) === Role.VAULT_ADMIN || ((_b = state.selectedWorkspace) === null || _b === void 0 ? void 0 : _b.role) === Role.BASIC_VAULT_USER; },
};
